export default __webpack_public_path__ + "static/project1-1e4dc3c5bf010ea76e45ee6a71ad513d.jpg";